
import axios from 'axios';
import { Component, Mixins, Watch } from 'vue-property-decorator';
import PageName from '../core/components/PageName.vue';
import { ItemInfo } from '../typescript/itemInfo';
import LoadingIndicator from '../core/components/Generics/LoadingIndicator.vue';
import Vue from 'vue'
import Button from '../core/components/Generics/Button.vue';
import { ItemWithSinistersApi } from '../../features/core/api/ItemWithSinistersApi'
import { ItemWithSinistersDetail } from '../item_with_sinisters/detailInfo'
import ItemIndicators from '../../features/item/components/ItemIndicators.vue'
import { SummaryIndicators } from '../../features/typescript/indicators';
import SinistersList from '../item_with_sinisters/components/sinisters/SinistersList.vue'
import { ColorsList, setAuthorizationHeader } from '../../features/core/utils';
@Component({
    components: {
        PageName,
        LoadingIndicator,
        Button,
        ItemIndicators,
        SinistersList
    }
})
export default class PageItemWithSinisters extends Vue {
    pendingInfo: boolean = false;
    errorDetail: boolean = false;
    detailInfo: ItemWithSinistersDetail | null = null;
    indicators: SummaryIndicators | null = null;
    orangeColor: string = ColorsList.mid_orange;

    created(){
        this.setToken()
    }
    
    setToken(){
        let tokenFromUrl = this.$route.params.token;
        setAuthorizationHeader(tokenFromUrl);

        if(tokenFromUrl){
            this.getItemInfo()
        }
    }

    mounted(){
        
    }

    closeItem(){
        let self = this;
        if(window.confirm('¿Desea salir del Item?')) {
            if(this.detailInfo && this.detailInfo.redirect_url){
                let haveUrl = this.detailInfo && this.detailInfo.redirect_url !== '';
                let redirectUrl = this.detailInfo.redirect_url;
                if(haveUrl) {
                    setTimeout(() => {
                        window.location.href = redirectUrl;
                    }, 800);
                }

                setTimeout(() => {
                    window.open('', '_self'); 
                    window.close();     
                }, 500);
            }
        }
    }

    getItemInfo(){
        this.errorDetail = false;
        this.pendingInfo = true;
        ItemWithSinistersApi.getItemWithSinistersInfo(
           
        ).then((response: ItemWithSinistersDetail) => {
            this.detailInfo = response;
            this.setItemIndicators(response);
        }).catch((error) => {
        this.errorDetail = true
        this.detailInfo = null 
        }).finally(() => {
            this.pendingInfo = false
            
        })
    }

    setItemIndicators(itemData: ItemInfo){
        const summaryData: SummaryIndicators = {
            crop_type: itemData.crop_type,
            declared_area: itemData.declared_area,
            department: itemData.department,
            province: itemData.province,
            campaign: itemData.campaign
        };
        this.indicators = summaryData;
    }

   

}
